/**
 * 应用指令汇总
 */
// export { default as inputNumber } from './input-number'
import submitClick from '../components/directives/submitClick.js'
import dialogDrag from '../components/directives/diag.js'

// 外部注册指令
export function registDirective(Vue) {
  Vue.use(submitClick)
  Vue.use(dialogDrag)
}

export { default as modalDrag } from './modal-drag'
export { default as removeAriaHidden } from './remove-aria-hidden'
